import type { KnowledgeBaseRepository } from "../repositories/knowledge-base-repository"

export const makeGetKbUesConfig = (repo: KnowledgeBaseRepository) =>
  (kbId: string) =>
    repo.getUesConfig(kbId)
